import { getUserId, fetchApi } from 'shared/functions';
import { watchlistItemTypes } from 'shared/constants/watchlistItemTypes';
import { toggleMode } from 'shared/constants/toggleMode';

const paramNames = {
  [watchlistItemTypes.DOSSIER]: 'dossierId',
};

const toggleModeToHttpMethod = {
  [toggleMode.ON]: 'POST',
  [toggleMode.OFF]: 'DELETE',
};

export const toggleWatchedState = async ({ mode, id, itemType }) => {
  const userId = getUserId();

  const resourceUrl = `/storefront/users/${userId}/watchlists`;

  const idParamName = paramNames[itemType];

  const params = {
    method: toggleModeToHttpMethod[mode],
    body: JSON.stringify({
      [idParamName]: id,
    }),
  };

  const response = await fetchApi(resourceUrl, params);

  if (!response.ok) {
    throw new Error('Failed to toggle watched state for portfolio');
  }
  return mode === toggleMode.ON ? response.json() : response;
};

export const SIGToggleWatchedState = async ({ id, itemType }) => {
  const userId = getUserId();
  const resourceUrl = `/sig/api/storefront/users/${userId}/watchlists/`;
  const idParamName = paramNames[itemType];

  const params = {
    method: 'PUT',
    body: JSON.stringify({
      [idParamName]: id,
    }),
  };

  const response = await fetchApi(resourceUrl, params);

  if (!response.ok) {
    throw new Error('Failed to toggle watched state for portfolio');
  }

  return response.json();
};
